import { gcoord_transform } from './coordinate.js';
import { getDirection } from './baseCommon.js';

//连接Web Sockek信息	
let pako = window.pako; //压缩 
let WEB_SOCKET_DEBUG = true;
let bUserCanUse = true;
let _WebSocket;
let iHeart = 0; //WebSocket心跳：0未登录，不发，1登录成功，2自动心跳不发

function connectSocketServer() {
  iHeart = 0;
  let support = "MozWebSocket" in window ? 'MozWebSocket' : ("WebSocket" in window ? 'WebSocket' : null);
  if (support == null) {
  }

  // create a new websocket and connect
  _WebSocket = new WebSocket('ws://jcts.hainancd.net:9015/');

  // when data is comming from the server, this metod is called
  _WebSocket.onmessage = function(evt) {
    try {
      let sReturn = "";
      if (typeof(evt.data) == "string") {
        let strDataTemp = atob(evt.data);
        let charData = strDataTemp.split('').map(function(x) {
          return x.charCodeAt(0);
        });
        sReturn = pako.inflate(new Uint8Array(charData), {
          to: 'string'
        });
        analize(sReturn);
      } else {
        let reader = new FileReader();
        reader.onload = function(evt) {
          if (evt.target.readyState == FileReader.DONE) {
            let dataBlob = new Uint8Array(evt.target.result);
            for (let k = 0; k < dataBlob.length; k++) {
              sReturn = sReturn + String.fromCharCode(dataBlob[k]);
            }
            analize(sReturn);
          }
        }
        reader.readAsArrayBuffer(evt.data);
      }

    } catch (e) {
    }
  };

  // when the connection is established, this method is called
  _WebSocket.onopen = function() {
    let sLogin = '{ "key": "Login", "data":[{"UserName": "hnylys", "Password": "hnylys@"}] }';
    _WebSocket.send(sLogin);
  };

  // when the connection is closed, this method is called
  _WebSocket.onclose = function() {
    iHeart = 0;
    if (!bUserCanUse) {
      return;
    }
    setTimeout(function() {
      connectSocketServer();
    }, 1000);
  }
}

function analize(sReturn) {
  try {
    if (sReturn == undefined || sReturn.length == 0) {
      return;
    }
    let arrData = JSON.parse(sReturn);
    $.each(arrData, function(i, data) {
      try {
        switch (data.key) {
          case "HeartReturn":
            if (data.info.length == 0) {
              iHeart = 1;
            } else {
              iHeart = 2;
            }
            break;
          case "LoginReturn":
            let iLoginFlag = data.data[0].LoginFlag;
            if (iLoginFlag == 0) {
              iHeart = 1;
            } else if (iLoginFlag == 1) {
              bUserCanUse = false;
            } else if (iLoginFlag == 2) {
              bUserCanUse = false;
            } else if (iLoginFlag == 3) {
              bUserCanUse = false;
            }
            break;
          case "0200": //位置数据
          // case "0201": //位置数据(应答)
          //case "0704_0": //批量位置数据（实时）
            locationReceive(data.key, data);
            break;
        }
      } catch (e) {
        
      }
    });
  } catch (e) {
  }
}

//接收位置信息
function locationReceive(key, data) {
  if (data.data.length == 0) {
    return;
  }
  let value = data.data[0];
  let simId = value["SIM_ID"];
  let longitude = value["LONGITUDE"]; //经度(WGS84)
  let latitude = value["LATITUDE"]; //纬度(WGS84)
  let locationTime = value["LOCATION_TIME"]; //定位时间
  let speedSatellite = value["SPEED_SATELLITE"]; //卫星测速仪回传速度
  let speedSensor = value["SPEED_SENSOR"]; //转速传感器回传速度
  let direction = getDirection(value.DIRECTION); //行驶方向

  let BD09 = gcoord_transform(gcoord.WGS84,gcoord.BD09,longitude,latitude); //转百度坐标经纬度

  callBackFunction("getSocketData",simId,BD09[0],BD09[1],locationTime,direction,speedSatellite,speedSensor,data);

  return false;
}

function callBackFunction(functionName, simId,longitude,latitude,locationTime,direction,speedSatellite,speedSensor,data){
  if (functionName in window) {
    if (typeof (eval(functionName)) == "function") {
      eval(functionName).call(document, 2, simId,longitude,latitude,locationTime,direction,speedSatellite,speedSensor,data);
    }
  }
}

function sendHeart() {
  if (iHeart == 2) {
    return;
  }
  let bOK = false;
  try {
    if (iHeart == 1) {
      let sData =
        "{\"code\":200,\"key\":\"HeartReturn\",\"TERMINALS_ID\":\"0\",\"SIM_ID\":\"000000000000\",\"info\":\"\",\"data\":[]}";
      _WebSocket.send(sData);
      bOK = true;
    }
  } catch (e) {
  }
  if (!bOK) {
    try {
      _WebSocket.close();
    } catch (e) {

    }
  }

  setTimeout(function() {
        sendHeart();
      }, 60000);
}

setTimeout(function() {
      sendHeart();
    }, 60000);

export { connectSocketServer }
